var React = require('react');

function IconExpand (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0C0.894531 0 0 0.895508 0 2V14C0 15.1045 0.894531 16 2 16H14C15.1055 16 16 15.1045 16 14V2C16 0.895508 15.1055 0 14 0H2ZM4 8.90137H7.11523V12H8.87695V8.90137H11.9922V7.13867H8.87695V4H7.11523V7.13867H4V8.90137Z","fill":"currentColor"}));
}

IconExpand.defaultProps = {"viewBox":"0 0 16 16","fill":"none","style":{"color":"#39424A"}};

module.exports = IconExpand;

IconExpand.default = IconExpand;
